import { RcFile } from 'antd/lib/upload'
import { ExternalCSVTransactionType } from 'api/transactions/dtos'
import { IIntegrationDto, IWalletDto } from './dtos'

export type SupportedBlockchainType = 'bitcoin' | 'ethereum' | 'ripple'
export enum SupportedBlockchainCoin {
	BTC = 'BTC',
	ETH = 'ETH',
	XRP = 'XRP',
}

export type SupportedExchangeType =
	| 'BINANCE'
	| 'BITFINEX'
	| 'BITSTAMP'
	| 'BITTREX'
	| 'COINBASE'
	| 'COINBASE_PRO'
	| 'GEMINI'
	| 'HITBTC'
	| 'ITBIT'
	| 'KUCOIN'
	| 'KRAKEN'
	| 'POLONIEX'

export type SupportedWalletType = 'EXODUS' | 'LEDGER' | 'COINOMI'

export type SupportedIntegrationType = SupportedExchangeType | SupportedWalletType
export interface IIntegration {
	id: string
	status: IIntegrationDto['syncStatus']
	name: string
	progress: number
	sourceType: IIntegrationDto['integrationType']
	error?: string
	total: number
	integrated: number
	integrationStartedAt: Date
	wallets: IWallet[]
	walletIds: string[]
	source?: string
	syncAllowed: number
	lastTransactionId?: IIntegrationDto['externalProviderLastTransactionId']
}

export interface IAPIImport {
	apiKey: string
	apiSecret: string
	userId?: string
	passphrase?: string
	integration: SupportedIntegrationType
}

export interface IAuthImport {
	authCode: string
	redirectUrl: string
	integration: SupportedIntegrationType
}

export interface ICSVImport {
	integration: SupportedIntegrationType
	file: RcFile
	s3Url: string
	type?: ExternalCSVTransactionType
}

export interface IScanBlockchain {
	walletAddress: string
}

export interface IWallet extends Pick<IWalletDto, 'id' | 'name' | 'transactions' | 'properties' | 'type'> {
	address?: string
	balances: {
		currency: string
		amount: number
		externalAmount: number
		value: number
	}[]
}

export interface ISaveWalletParams {
	id?: IWallet['id']
	name: IWallet['name']
	address?: IWallet['address']
}

export interface IVezgoIntegrateParams {
	accountId: string
	source: string // exchange or wallet supported by vezgo
}

export interface IVezgoSyncParams {
	integrationId: string
	source: string
}

export interface IMerlinSyncParams {
	integrationId: string
}

export interface IWealthicaSyncParams {
	mode: 'SYNC_METHOD_APPEND' | 'SYNC_METHOD_OVERRIDE'
	transactions: any[] // forwarded Wealthic transaction format which UI should not care about
	vezgoTransactions: any[] // mapping list of the vezgo formatted transactions
	silent?: boolean
}
